<script>
import Spinner from './spinner.vue'
export default {
  components: { Spinner },
  props: {
    title: {
      type: String,
      default: () => 'No Title',
    },
    actionTitle: {
      type: String,
      default: () => 'Confirm',
    },
    actionSubtitle: {
      type: String,
      default: () => '',
    },
    action: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      show: false,
    }
  },

  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
  },
}
</script>

<template>
  <v-dialog v-model="show" width="600">
    <v-card class="pa-4">
      <p class="text-h5 font-weight-bold text-center mb-8">
        {{ title }}
      </p>

      <slot v-if="!loading" name="content"></slot>
      <Spinner v-else class="h-full" size="60" />
      <p
        v-if="actionSubtitle.length"
        class="subtitle-2 grey--text lighten-1 mt-8 mb-2 text-center"
        >{{ actionSubtitle }}</p
      >
      <v-card-actions class="d-flex justify-space-around">
        <v-btn class="text-button py-6 px-8" text @click="close"> Back </v-btn>

        <v-btn
          color="primary"
          class="py-6 px-8 text-button"
          depressed
          @click="action"
        >
          {{ actionTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
